/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { MaintenanceTasksOverdueDto } from '../dto';

export const MaintenanceTasksOverdueMapper = entity<MaintenanceTasksOverdueDto>({});
